/* eslint-disable import/no-anonymous-default-export */
export default {
  MIA_PAYMENT: 'MIA payment',
  commentForPicker: 'Commentary for the collector',
  howToUsePromocode: 'How to use a promo code?',
  noPromos: 'You dont have any promos yet.',
  noOptions: 'No options',
  hide: 'Hide',
  notWorking: 'Not working',
  chisinauDeliver: 'delivery in Chișinău',
  categoryNotFound: 'There are currently no restaurants available in this category!',
  categoryViewOpenedRestaurants: 'View open restaurants',
  cookieConsentTextMob: '🍪 We use cookies.',
  cookieConsentText:
    '🍪 We use cookies to improve your experience. By using our website, you agree to our cookie policy.',
  okay: 'Ok',
  cartSurchargeDescription: `We gain money from the order's commission. If the check amount is small, it is not enough to cover the delivery expenses.  In order to not fix a minimum amount for the order, we apply a little surcharge for the customers that make an order which costs less then 200 lei. We love you! 😍`,
  smallOrder: 'Extra charge for small order',
  promoCodeRequired: 'You must be logged in to use the promo code',
  promoCode: 'Promo code',
  promoUsageLimit: 'Usage Limit',
  promoDetails: 'Details',
  promoMinRequirement: 'Minimum Requirement',
  promoDiscount: 'Discount',
  promoRestrictions: 'Restrictions',
  promoValidUntil: 'Valid Until',
  promoCurrency: 'MDL',
  selectRegion: ' depends on the neighborhood. Choose your neighborhood!',
  selectRegionDelivery: 'The price for delivery',
  showMore: 'Show more',
  showLess: 'Show less',
  loginRequired: 'You must be logged in to place an order.',
  onlyCashPayment: 'Only cash',
  viewMore: 'all',
  askForAddress: 'Are you sure you are at this address?',
  addAddressTitle: 'Enter delivery address',
  addAddressDescription: 'Or else how will we know where to deliver?',
  fewRatings: 'Few ratings',
  showMapInfo: 'Not your address?',
  showMap: 'Show on map',
  address: 'Adress',
  courier_express: 'Courier Express',
  markets: 'Markets',
  restaurants: 'Restaurants',
  closeMaibModalDisclaimer:
    'If you close the window during payment processing, it may result in unsuccessful completion.',
  payApplePayGpay: 'Apple/Google Pay',
  paymentMethodTemporarilyDisabled: 'Temporarily unavailable',
  myPromocodes: 'My promocodes',
  each_n_free: 'Each {0} order - free delivery 🚚',
  each_n_free_disclaimer: '🎊 In the new month the count starts fresh! Take advantage of the benefit �',
  changeCard: 'Change card',
  saveCard: 'Save card',
  dontSaveCard: 'Do not save card',
  deleteCardInfo: `Are you sure? You can't undo this action.`,
  deleteCardTitle: 'Delete card',
  promoCodeCopied: 'Promo code copied successfully',

  payWithNewCard: 'Pay with new card',
  all: 'All',
  surchargeBadWeather: 'Bad weather allowance',
  orderDetailsCourierExpressStatus1: 'We are waiting for the operator’s confirmation. Usually it takes 3 minutes. ⏳',
  orderDetailsCourierExpressStatus2: 'The courier knows about your order and will pick it up as soon as possible. 🥷',
  orderDetailsCourierExpressStep2: `Soon we'll pick up`,
  orderDetailsCourierExpressStatus3:
    'The courier picked up the order. There is not much left to wait, wish him to arrive without traffic jam. 🏎️',
  orderDetailsCourierExpressStep3: 'Courier picked up',
  orderDetailsCourierExpressStatus4:
    'Your hero is there, meet him with a smile. Flowers are not needed, tips are appreciated. 💶 😁',

  errorCourierExpressComment: 'Please add a comment to the order',
  errorCreatingOrder: 'Error on creating order.',
  orderCreated: 'Order created successfully',
  whereFrom: 'where from?',
  whereTo: 'where to?',
  expressSender: 'Sender details',
  expressSenderDescription: 'Pickup location details',
  expressReceiver: 'Recipient details',
  expressReceiverDescription: 'Details about where do we deliver the package',
  expressInfoDelivery: 'Information about delivery',
  courierExpressPhotoUpload: 'Add photo',
  courierExpressCommnetHead: 'Describe the items to be delivered',
  courierExpressCommnetDescription: 'Describe in detail what we should deliver, and attach a photo if possible 🛍️',
  courierExpressDescription: 'Whatever you need — delivered across your city.',
  courierExpress: 'Parcel delivery',
  expressChooseAddresses: 'Select where fron and where To addresses',
  notificationTitle: "Allow notifications so you don't miss discounts and promotions.",
  welcomeTitle: 'Welcome!',
  welcomeMessage: 'Thank you for subscribing to our notifications.',

  order: 'Order',
  soon: 'Coming soon',
  cartFreeDeliveryInfo: "and you'll get free delivery on the first order! 🎉",
  nameRequired: 'Please add your name',
  invalidEmail: 'Invalid email address',
  tooHighNumber: 'Number too high',
  validNumberWithoutDecimals: 'Please enter a valid number without decimal values',
  phoneRequired: 'Phone is required',
  addressNotSelected: 'Address is not selected',
  appartament_office: 'Apartment/office',
  SELECT_CARD: 'Select Card',
  CARD_REMOVED: 'Card removed',
  noCards: 'You dont have any cards added.',
  myCards: 'My Cards',
  addNewCard: 'Add new card',
  selectedCardDetails: 'This will be the card which you will pay online',
  accountBlockedTitle: 'Urgent Account Notification: Your account is blocked',
  accountBlockedDescription: `Dear {0},

We regret to inform you that your account on our platform has been temporarily blocked due to suspicious activity, overdue payments.

Please be assured that we are actively working to solve this issue as soon as possible. Our top priority is to ensure the security and integrity of your account and any associated data.

In the meantime, if you have any urgent inquiries or concerns, please don't hesitate to contact our customer support. We appreciate your understanding and cooperation in this matter.

Sincerely, STRAUS Team`,
  yes: 'Yes',
  no: 'No',
  nightSurcharge: 'Extra cost for the Night delivery\n(from 00:00 till 06:00)',
  ADULTS_ONLY_CANCEL: `No, I'm not`,
  ADULTS_ONLY_CONFIRM: `Yes, I am`,
  СONTAINS_ADULTS_PRODUCTS: `This provider contains products from "adults only" category. Please confirm that you are 18+ years old`,
  ATTACH_FILE: 'Attach a photo',
  DAILY_SPECIALS: 'Dish of the day',
  CATEGORY: 'Category',
  ENTER_PHONE_NUMBER: 'Enter your phone number',
  PHONE_NUMBER_NOT_VALID: 'Invalid phone number',
  SMS_WAS_SENT: 'SMS code was sent to',
  SMS_CODE_NOT_RECEIVED: "Didn't get the code?",
  BRAND_NEW: 'New!',
  MY_DETAILS: 'My details',
  MY_ADDRESSES: 'My addresses',
  FAVORITES: 'Favorites',
  SUPPORT: 'Support',
  LOGOUT: 'Logout',
  NEED_HELP: "Do you need help? Chat or call us and we'll solve it!",
  PLEASE_CHECK_POLICY: 'Please check policy',
  RECIPIENT_DATA_REQUIRED: 'recipient data is required',
  CALL_US: 'Let me know if you have any problems with the delivery',
  ADDED: 'Added',
  ADD: 'Add',
  ADD_TO_CART: 'Add to cart',
  CLEAR_TO_CART: 'Clear cart',
  CLEAR_TO_CART_DESCRIPTION_PART1: 'You have items from ',
  CLEAR_TO_CART_DESCRIPTION_PART2: 'Cart needs to be emptied for a new order ',
  ADD_COMMENT: 'Add your comment',
  DELETED: 'Product removed',
  DELETE: 'Delete',
  DELETE_ADDRESS: 'Delete address',
  SAVE_ADDRESS: 'Save address',
  SAVE: 'Save',
  HELLO: 'Hello',
  ARE_YOU_SHURE: 'Are you sure?',
  LANG: 'English',
  LANGUAGE_SELECT_TITLE: 'Select language',
  ORDERS: 'Orders',
  ORDER_EVALUATED: 'Evaluated',
  NOT_FOUND: 'This page does not exist',
  NOT_FOUND_MARKET: 'This market not found',
  NOT_FOUND_RESTAURANT: 'This restaurant not found',
  NOT_FOUND_CATEGORY: 'This category not found',
  NOT_FOUND_PROVIDER_SUBTITLE: 'Choose another restaurant or product',
  NOT_FOUND_SUBTITLE: 'Actually it exists, but only so that you know that the page you need ... does not exist! Sorry!',
  SELECT_ADDRESS: 'Add address',
  ADD_NEW_ADDRESS: 'Add new address',
  ADDRESS_REMOVE_SUCCESS: 'Address was successfully removed',
  ADDRESS_REMOVE_ERROR: 'Error on removing the address',
  ADDRESS_CREATE_ERROR: 'Error on creating the address',
  ADDRESS_UPDATE_ERROR: 'Error on updating address ',
  ADDRESS_SELECT_ERROR: 'Error on selecting address ',
  SEARCH: 'Search',
  SEARCH_INPUT_FOR_RESTAURANTS: 'Restaurants search',
  SEARCH_IN: 'Search in',
  SEARCH_INPUT_FOR_MARKETS: 'Markets search',
  SEARCH_NOT_FOUND: 'No results found',
  SEARCH_RESULTS: 'Search results',
  CURRENCY: 'MDL',
  RESTAURANTS_TITLE: 'Restaurants',
  MOBILE_SIDE_BAR_TITLE: 'Hello',
  RESTAURANT: 'Restaurant',
  MARKET: 'Market',
  RESTAURANTS_SUB_TITLE: 'More than 250  restaurants ',
  SHOPS_TITLE: 'Shops',
  SHOPS_SUB_TITLE: 'More than 50 markets ',
  SHOPS_FIND: 'Stores found',
  EXPRESS_COURIER: 'Courier Service',
  EXPRESS_COURIER_SUB_TITLE: 'Available on our mobile app',
  COURIER_NAME: 'Courier',
  CATEGORY_TITLE: 'What would you like today? ',
  RESTAURANT_CATEGORY: 'Restaurant category',
  DOWNLOAD_THE_APPLICATION: 'Download the Straus app',
  DOWNLOAD_THE_APPLICATION_SUB_TITLE: 'Make ordering easier — your time matters to us',
  INFORMATION: 'Information',
  INFORMATION_SUB_TITLE_FOR_US: 'About us',
  INFORMATION_SUB_TITLE_PARTNERS: 'Become a Straus Partner',
  INFORMATION_SUB_TITLE_CAREERS: 'Join the Team',
  GENERAL: 'General',
  GENERAL_TEAMS: 'Terms and conditions',
  GENERAL_PROCESSING_PERSONAL_DATA: 'Processing the personal data',
  ERROR_UPDATE_DATA: 'Error on updating data',
  SUCCESS_UPDATE_DATA: 'Success on updating data',
  CONTACT: 'Contact',
  FOLLOW_US_ON: 'Follow us on',
  VIEW_ALL: 'View all',
  PROMOTION_TITLE: 'Promotions',
  RECOMMENDED_RESTAURANTS: ' We recommend ',
  TOP_RESTAURANTS: ' We recommend',
  NEW_RESTAURANTS_ON_STRAUS: 'New on Straus',
  SORT_RECOMMENDED: 'Recommended',
  SORT_ONLINE_PAYMENT: 'Online payment',
  SORT_BY: 'Sort by',
  FILTER_TITLE: 'Filter',
  FILTERS_MORE: 'More filters',
  FILTER_RESET: 'Reset',
  RESTAURANTS_FIND: ' provider found',
  FILTER_BY_CATEGORY: 'What would you like today? ',
  FILTER_BY_BENEFITS: 'Filter by benefits',
  SOMETHING_WENT_WRONG: 'Something went wrong',
  DETAILS: 'Details',
  DETAILS_PROVIDER: 'Details',
  DELIVERY_TIME: 'Delivery time',
  DELIVERY_TERMS: 'Delivery terms',
  DELIVERY_METHOD: 'When to deliver?',
  DELIVERY_ZONE: 'Delivery zone',
  PAYMENT_METHOD: 'Payment method',
  FAVOURITE: 'Favorite',
  FAVOURITE_ADD: 'Added to favorite',
  ERROR_FAVOURITE_ADD: 'Error on add to favorite',
  FAVOURITE_REMOVE: 'Removed from favorites',
  ERROR_FAVOURITE_REMOVE: 'Error on remove from favorites',
  FAVOURITE_IS_EMPTY: "You don't have any favorites yet",
  EMPTY_FAVORITES: 'No favorites yet',
  DELIVERY: 'Delivery',
  DELIVERY_FROM: 'Delivery from',
  MINUTES: 'min',
  CLOSING_PROVIDER: 'Сloses at',
  WILL_OPEN_PROVIDER: 'Will open at ',
  WILL_OPEN_TOMORROW_PROVIDER: 'Will open tomorrow at',
  WILL_OPEN_TODAY_PROVIDER: 'Will open today in',
  TODAY: 'Today at',
  TOMORROW: 'Tomorrow at',
  CLOSING_PROVIDER_DESCRIPTION:
    'is currently closed, you have the option to continue and pre-order or view others open providers',
  PAUSE_PROVIDER_DESCRIPTION:
    'Right now we are delivering from the nearest restaurants to you, but the %providerName% is a bit far away. Just don’t be angry ❤️, choose another nearest restaurant.',
  PAUSE_PROVIDER_DESCRIPTION_PS:
    'P.S. Brotherly, maybe you have friends who would like to try themselves as a courier, please advise us! Thanks 🤗',
  PAUSE: 'Pause',
  PAUSE_UNTIL: 'Pause until',
  OVERLOADED: 'Overloaded',
  OVERLOADED_TO: 'Overloaded until',
  AVAILABLE: 'Available',
  CONTINUE_HERE: 'Сontinue',
  OPEN_PROVIDER: 'View open',
  OPEN_PROVIDER_IN: 'will open at',
  PROVIDER_NO_REVIEWS: 'no reviews yet',
  REVIEW: 'Review',
  SUCCESS_SEND_REVIEW: 'Your review has been sent successfully, thank you!',
  ERROR_SEND_REVIEW: 'Error send review!',
  PRODUCTS: 'Products',
  ADD_MORE_PRODUCTS: 'Add something more for',
  SHOW_MORE_PROVIDERS: 'Show more',
  ADD_MORE_PRODUCTS_DESCRIPTION: 'and you’ll get a discount -',
  ADD_MORE_PRODUCTS_DESCRIPTION_FREE: 'and shipping will be FREE! 🆓',
  ORDERED_PRODUCTS: 'ordered products',
  ORDER_CREATE_ERROR: 'Error on creating order',
  MY_ORDERS: 'My orders',
  DISCOUNT: 'Discount',
  APPLY: 'Apply',
  FREE: 'Free delivery',
  ADDRESSES_IN_CHISINAU: 'Address in Chișinău:',
  WORK_PROGRAM_TODAY: 'Schedule:',
  CHAT: 'Chat',
  SOUNDS: 'Call',
  YOUR_ORDER: 'Your order',
  NEXT_STEP: 'Next step',
  CART: 'Cart',
  CART_EMPTY: 'Empty cart',
  GO_TO_CART: 'Go to cart',
  CUTLERY: 'Cutlery',
  CUTLERY_DESCRIPTION:
    'In order to protect the environment, plastic cutlery is not included in the order. Add them for free, only if you really need it.',
  COMPLETE_ORDER: 'Anything else? ',
  SPECIAL_MENTIONS: 'Special mentions',
  ADD_SPECIAL_MENTIONS: 'You can add a comment',
  ORDER_SUMMARY: 'Order summary',
  ORDER_DELIVERED: 'Order delivered',
  TOTAL_PRODUCTS: 'Total products',
  TOTAL_ORDER: 'Total order',
  ORDER_COMPLETION: 'Order completion',
  ORDER_DETAILS: 'Order details',
  ORDER_STATUS_HERE: 'Order status here',
  ORDER_CANCEL: 'Cancel the order',
  ORDER_CANCEL_DESCRIPTION: 'To cancel an order, please provide a reason.',
  ORDER_CANCELED: 'The order is canceled',
  ORDER_SEND: 'Send order',
  ORDER_NUMBER: 'Order number',
  ORDER_LOADING: 'Order loading',
  EVALUATE_ORDER: 'Leave a review  ',
  CHECKOUT: 'Checkout',
  PRE_ORDER_SUB_TITLE: 'by clicking this button you can place a  pre-order',
  PRE_ORDER_REQUIRED: 'Preorder is required',
  ADD_PRE_ORDER: 'Preorder',
  NO_PRE_ORDER: 'Pre-order is not available',
  SELECT_TIME_AND_DAY: 'Select time',
  SELECT: 'Select',
  SELECT_MAX_OPTIONS: 'Select max',
  SELECT_OPTIONS: 'Select options',
  OPTIONS: 'options',
  CANCEL: 'Cancel',
  DELIVERY_TO_ADDRESS: 'Delivery to the address',
  DELIVERY_COST_INFO_TITLE: 'How much is shipping?',
  DELIVERY_COST_INFO_DESCRIPTION_PART1:
    'The cost of delivery depends on the distance - the shorter the distance' +
    'our couriers cover, the lower the cost of delivery. An additional surcharge ' +
    'of 20 lei arises for addresses from remote areas.',
  DELIVERY_COST_INFO_DESCRIPTION_PART2:
    'When placing an order at one of the establishments, you will see the total cost ' +
    'for delivery before it is confirmed. The base shipping cost depends on our agreement ' +
    'with the establishment where you place your order - to find out the base shipping cost, ' +
    'click on the icon of the establishment, the base shipping cost is displayed at the top of ' +
    'the page. For example: “Delivery from 39 lei”. Thus, you will know the total amount ' +
    'due before the order is confirmed.',
  PERSONAL_LIFT: 'Personal Lift (Coming Soon)',
  HOME: 'Home',
  I_WORK_HERE: 'Deliver here ',
  OFFICE: 'Office',
  UNTITLED: 'Other',
  ADDRESS_DETAILS: 'Delivery address',
  ADDRESS_APT_OFFICE: '№ Apt./Office',
  INTER_PHONE: 'Interphone',
  USER_PHONE_NUMBER: 'phone number',
  USER_PHONE_NUMBER_DESCRIPTION: 'We will keep in touch on this phone number',
  STAIRS: 'Stair',
  FLOOR: 'Floor',
  ADDRESS_PRIVATE_HOUSE: 'Private house',
  CHANGE_ADDRESS: 'Save',
  FORCE_CHANGE_ADDRESS: 'Change address',
  ALERT_CHANGE_ADDRESS: 'Attention! You are about to change your delivery address.',
  ALERT_CHANGE_ADDRESS_MESSAGE: 'If you change your delivery address, your cart will empty. Delete current address?',
  ONLINE_CARD_PAYMENT: 'Online card payment',
  ONLINE_CARD_PAYMENT_MESSAGE: 'Payment on the bank’s page, we don’t save your data ',
  CASH_PAYMENT_ON: 'Cash payment on delivery',
  USER_NAME: 'Name',
  USER_NAME_PLACEHOLDER: 'Your name',
  USER_AGREEMENT: 'User Agreement',
  USER_NAME_AND_SURNAME: 'Name',
  USER_NAME_DESCRIPTION: 'We accept nicknames too ',
  EMAIL_PLACEHOLDER: 'Email',
  EMAIL_DESCRIPTION: 'Here we send recipes and letters, I hope you got the password',
  VOUCHER_TITLE: 'Do you have a promo code?',
  VOUCHER: 'Promo code',
  ADD_VOUCHER: 'Add Promo code',
  ADD_VOUCHER_PLACEHOLDER: 'Write your promo code',
  VOUCHER_DESCRIPTION: 'Write a new promo code',
  ORDER_STATUS_AUTO_CONFIRMED: 'Auto confirmed order',
  ORDER_STATUS_4: 'The courier is near, wait for him',
  ORDER_STATUS_DELIVERED: 'Order delivered',
  YOU_HAVE_NO_ORDERS: 'You have no orders yet',
  DURATION_ORDER_TITLE: 'The order arrives in about',
  HELP: 'Help',
  LOGIN_TITLE: 'Login',
  CLEAR_CART_TITLE: 'Are you sure you want to empty the cart?',
  CLEAR: 'Empty',
  CLEAR_CART_DESCRIPTION: 'You need to empty the cart in order to make a new order',
  ADDING_PRODUCT_FROM_ANOTHER_RESTAURANT_TITLE: 'Empty cart? ',
  LEAVE_PRODUCTS: 'Leave products',
  RESTAURANT_NEARBY: 'Nearby restaurants',
  PREORDER: 'Preorder',
  COMPLETE_ALL_FIELDS: 'Complete all the fields',
  FIELD_IS_REQUIRED: 'Field is required.',
  IS_REQUIRED: 'Required.',
  THIS_FIELD_IS_TOO_LONG: 'This field is too long',
  GO_TO_MAIN_PAGE: 'Go to main page',
  TO_PLAN: 'Schedule for',
  PAY_ORDER: 'Pay for the order',
  ORDER_IS_PAID: 'This order is paid',
  ORDER_FOR_SELF_TITLE: 'I order for myself',
  ERROR_ORDER_IS_PAID: 'Payment error for this order',
  RECOMMENDED_PRODUCT: 'Recommend',
  RECIPIENT_DATA: 'Recipient data',
  POLICY_PART_1: 'I have read and agree with',
  POLICY_PART_2: 'User agreement',
  POLICY_PART_3: 'and I consent to the processing of my personal information according with the terms',
  POLICY_PART_4: 'Privacy Policy',
  BASE_DELIVERY_TIME: 'Delivery in an average of 50 minutes',
  DELIVERY_DETAILS_DESCRIPTION:
    'The cost and average delivery time can be found on the page of the restaurant you are interested in. ' +
    'Delivery time will be shortened if your delivery address is in the same area as the restaurant’s address .' +
    'We deliver orders within the specified zone on the map.' +
    'If your address is outside the specified area, please specify cost, time and possibility of delivery at the moment with our operators. ' +
    'Ask your questions via chat or call by phone 0(22)899-999',
  ABOUT_US_TITLE: 'Who are we?',
  ABOUT_US_DESCRIPTION:
    'Straus is the best food ordering and delivery service! ' +
    'You get access to the menu of dozens of restaurants, and you can also get acquainted with their rating and special offers. ' +
    'We value your time, so we want to provide an opportunity to easily and simply place an order, and our team will deliver it to your home, ' +
    'office or anywhere in the city in the shortest possible time. Our menu lists 250 restaurants, cafes, pizzerias, sushi bars and pubs. ' +
    'With the STRAUS team - you will never be hungry!',
  CONTACT_US: 'Contact us',
  ADDRESS_OFFICE: 'Chisinau, str-la Teatrului 15/1',
  ACTIVE_ORDERS: 'Active orders',
  YOUR_CART_IS_EMPTY: 'Your cart is empty',
  CLOSE_PROVIDER: 'Closed',
  TEMP_CLOSE_PROVIDER: 'Temporarily closed',
  TODAY_IN: 'today in',
  TOMORROW_IN: 'Tomorrow in',
  SCHEDULE_FOR: 'schedule for',
  EVALUATE_ORDER_RATE_FORM_TITLE: 'What were the products from ',
  EVALUATE_COURIER_RATE_FORM_TITLE: 'How do you like the delivery made ',
  ORDER_STATUS_1_NEW_ORDER_FOR_RESTAURANT:
    'We are waiting for the restaurant to confirm the order, usually it takes 3 min ⏳',
  ORDER_STATUS_1_NEW_ORDER_FOR_MARKET: 'We are waiting for the market to confirm the order, usually it takes 3 min ⏳',
  ORDER_STATUS_2_FOR_RESTAURANT:
    'The restaurant confirmed the order and started preparing your delicious treats 🧑‍🍳, unless it s a pre-order, of course.',
  ORDER_STATUS_2_FOR_MARKET:
    'The restaurant confirmed the order and started assembling it 🛍️, of course if it is not a pre-order',
  ORDER_STATUS_3_RESTAURANT: 'The courier is already in the restaurant, waiting for the delivery of the order  🥷',
  ORDER_STATUS_3_MARKET: 'The courier is already in the store, waiting for the delivery of the order  🥷',
  COURIER_RIDES:
    'The courier was given an order, now it s not long to wait, wish him to get there without traffic jams 🏎️',
  COURIER_SLOGAN: 'I will come to you as soon as possible',
  COURIER_NUMBER_PHONE: 'Courier number',
  RESTAURANT_DELIVERING:
    "The restaurant confirmed the order and started preparing your delicacies 🧑‍🍳, if this is definitely not a pre-order. Enjoy your appetite and don't forget to rate the order! ⚠️ The restaurant courier will deliver the order, you will not be able to track the status of the order here. If you have any questions about the order, call us, we'll help!",
  NO_RESULTS_SEARCH_ADDRESS: 'No results',
  SEARCH_ADDRESS_PLACEHOLDER: 'Street and number',
  YOU_HAVE_18_YEARS: 'You are already 18 years old',
  NOT_FAVOURITES: 'You don t have favorites',
  MY_DATA: 'My details',
  FOR_ADULT: '18+',
  BANNER_REDIRECT_ON_MOBILE_APP_TITLE: 'Straus has a cool mobile app',
  DOWNLOAD_MOBILE_APP: 'Download mobile app',
  STOP_RUN_SITE:
    'Hello, friend!' +
    'We have technical issues now, please make the order on the mobile app Straus.\n' +
    'Sorry for the inconvenience.',
  PRESENTATION_IMAGE_WARNING: 'The products in the image are for presentation',
  WEIGHTED: 'Weighted',
  NON_STOP: 'Non-stop',
  LIKE: 'Yes I liked it!',
  DISLIKE: 'I do not like it!',
  WHAT_CAN_IMPROVE: 'What can improve?',
  FAR_AREA_SURCHARGE: 'Far area surcharge',
  LOCATION_OUTSIDE_DELIVERY: 'Location outside Straus delivery zone',
  LOCATION_SEARCH_ERROR: 'Location getting error. Try again',
  GEOLOCATION_NOT_SUPPORTED: 'Geolocation not supported',
  REQUIRE_GEOLOCATION_PERMISSIONS: 'Require geolocation permissions',
  INGREDIENTS: 'Ingredients',
  STORAGE_INSTRUCTIONS: 'Storage instructions',
  BRAND: 'Brand',
  COUNTRY_OF_ORIGIN: 'Country of origin',
  WILL_BE_USEFUL: 'Will be useful',
  FREE_DELIVERY_PROMO_CONFLICT_TITLE: 'Promo code will cancel free shipping',
  FREE_DELIVERY_PROMO_CONFLICT_TEXT: 'If you use a promo code, free shipping will not apply.',
  //Metro
  MAIN: 'Main',
  PRICE: 'Price',
  DEFAULT: 'Default',
  CHEAP: 'Cheap',
  EXPENSIVE: 'Expensive',
  CONTINUE: 'Continue',
  FILTERS: 'Filters',
  TRADEMARK: 'Trademark',
  COUNTRY: 'Country',
  PURPOSE: 'Purpose',
  AMOUNT: 'Amount',
  PROFITABLE_SHELF: 'Discounts and promotions',
  PRODUCT_CATEGORIES: 'Product categories',
  NOT_AVAILABLE: 'Not available',
  CATEGORIES: 'Categories',
  PCS: 'pcs',
  KG: 'kg',
  ALPHABETICALLY_A_Z: 'Alphabetically A-Z',
  ALPHABETICALLY_Z_A: 'Alphabetically Z-A',
  IS_NEW: 'New',
  ONLY_IN_STOCK: 'Only in stock',
  BACK: 'Back',
  CLEAR_FILTERS: 'Clear filters',
  CLOSE: 'Close',
  PROMOTIONAL_ITEMS: 'Promotional items',
  SHOW_ALL: 'Show all',
  FAVORITE_PRODUCTS: 'Favorite products',
};
